declare const google: any;

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';

@Injectable()
export class GeoLocationService {
  private locationLatitude = null;
  private locationLongitude = null;
  private accessCount = 0;
  constructor() { }
  getCurrentPosition(): Observable<Position> {
    return new Observable((observer: Observer<Position>) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position: Position) => {
            observer.next(position);
            observer.complete();
          },
          (error: PositionError) => {
            console.log('Geolocation service: ' + error.message);
            observer.error(error);
          }
        );
      }
    });
  }
  public setLongitide(longitude) {
    this.locationLongitude = longitude;
  }
  public getLongitude() {
    return this.locationLongitude;
  }
  public setlatitude(latitude) {
    this.locationLatitude = latitude;
  }
  public getLatitude() {
    return this.locationLatitude;
  }

  public getLocationNameByLatLang(coords) {
    const latlng = new google.maps.LatLng(coords.latitude, coords.longitude);
    const geocoder = new google.maps.Geocoder();
    return Observable.create(observer => {
      geocoder.geocode({ 'latLng': latlng }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            for (let i = 0; i < results[0].address_components.length; i++) {
              const ac = results[0].address_components[i];
              if (ac.types.indexOf('locality') >= 0) {
                observer.next(ac.short_name);
                observer.complete();
              }
            }
          }
        } else {
          observer.next({});
          observer.complete();
        }
      });
    });
  }

  public getAccessCount() {
    return this.accessCount;
  }

  public setAccessCount() {
    this.accessCount = 1;
  }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/location/geo-location.service.ts